import { IApiError } from '@frontend/request';

import { IAccountLinkParams, IAccountLinkRemoveParams, accountLinkAPI } from '@aqx-core/common/api/account-link';
import { IAPIControllerCallbacks } from '@aqx-core/common/api/types';

class AccountExperienceAPIController {
  public linkAccount = async (params: IAccountLinkParams, callbacks: IAPIControllerCallbacks<boolean>) => {
    try {
      const { result } = await accountLinkAPI.linkAccount(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public removeLinkedAccount = async (
    params: IAccountLinkRemoveParams,
    callbacks?: IAPIControllerCallbacks<boolean>
  ) => {
    try {
      const { result } = await accountLinkAPI.removeLinkedAccount(params);
      callbacks?.onSuccess(result);
    } catch (error) {
      callbacks?.onError(error as IApiError);
    }
  };

  public verifyLinkedAccountPassword = async (
    params: IAccountLinkParams,
    callbacks: IAPIControllerCallbacks<boolean>
  ) => {
    try {
      const { result } = await accountLinkAPI.verifyPassword(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };
}

export const accountExperienceAPIController = new AccountExperienceAPIController();
